import { createContext, useContext } from "react";
const RadioContext = createContext(null);
function useRadioProvider() {
  return useContext(RadioContext) || {};
}
export {
  RadioContext,
  useRadioProvider
};
